import { INITIALIZE_ROI_PROGRESS } from '../actionTypes';
import { actions } from '../reducer';

export default (values) => actions[INITIALIZE_ROI_PROGRESS](values);
